import getRouterBasename from '@/lib/router';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import RequireSubscription from '@/components/RequireSubscription';

import AuthCallback from 'pages/AuthCallback';
import Dashboard from 'pages/Dashboard';
import MallarContracts from 'pages/MallarContracts';
import MallarEditor from 'pages/MallarEditor';
import Projects from 'pages/Projects';
import Element from 'pages/Element';
import Env from 'pages/Env';
import ForgotPassword from 'pages/ForgotPassword';
import Home from 'pages/Home';
import Login from 'pages/Login';
import ManageSubscription from 'pages/ManageSubscription';
import PaymentSuccess from 'pages/PaymentSuccess';
import Project from 'pages/Project';
import ResetPassword from 'pages/ResetPassword';
import Signup from 'pages/Signup';
import Subscribe from 'pages/Subscribe';
import Thread from 'pages/Thread';

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: (
        <RequireSubscription>
          <Home />
        </RequireSubscription>
      )
    },
    {
      path: '/env',
      element: <Env />
    },
    {
      path: '/thread/:id?',
      element: (
        <RequireSubscription>
          <Thread />
        </RequireSubscription>
      )
    },
    {
      path: '/project/:projectId',
      element: (
        <RequireSubscription>
          <Project />
        </RequireSubscription>
      )
    },
    {
      path: '/element/:id',
      element: (
        <RequireSubscription>
          <Element />
        </RequireSubscription>
      )
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/signup',
      element: <Signup />
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />
    },
    {
      path: '/reset-password/:token',
      element: <ResetPassword />
    },
    {
      path: '/login/callback',
      element: <AuthCallback />
    },
    {
      path: '/subscribe',
      element: <Subscribe />
    },
    {
      path: '/payment-success',
      element: <PaymentSuccess />
    },
    {
      path: '/dashboard',
      element: (
        <RequireSubscription>
          <Dashboard />
        </RequireSubscription>
      )
    },
    {
      path: '/manage-subscription',
      element: (
        <RequireSubscription>
          <ManageSubscription />
        </RequireSubscription>
      )
    },
    {
      path: '/projects',
      element: (
        <RequireSubscription>
          <Projects />
        </RequireSubscription>
      )
    },
    {
      path: '/mallar',
      element: (
        <RequireSubscription>
          <MallarContracts />
        </RequireSubscription>
      )
    },
    {
      path: '/mallar/contract/:contractId',
      element: (
        <RequireSubscription>
          <MallarEditor />
        </RequireSubscription>
      )
    },
    {
      path: '/share/:id',
      element: (
        <RequireSubscription>
          <Thread />
        </RequireSubscription>
      )
    },
    {
      path: '*',
      element: <Navigate replace to="/" />
    }
  ],
  { basename: getRouterBasename() }
);
